import { render, staticRenderFns } from "./kitviewer.vue?vue&type=template&id=20489494&scoped=true"
import script from "./kitviewer.vue?vue&type=script&lang=js"
export * from "./kitviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20489494",
  null
  
)

export default component.exports